import { defineStore } from "pinia";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    adminToken: localStorage.getItem("admin_token") || "",
  }),
  actions: {
    setToken(t) {
      this.adminToken = (t || "").trim();
      if (this.adminToken) localStorage.setItem("admin_token", this.adminToken);
      else localStorage.removeItem("admin_token");
    },
    logout() {
      this.setToken("");
    },
  },
});
